/* Konfigurátor obrazu — Galerie Signature.
   Kroky: 1 Materiál → 2 Provedení → 3 Barva a typ rámu (jen u provedení s rámem) → 4 Velikost.

   Zdroje pravdy:
   - dostupnost kombinací a ceny = varianty produktu v Shopify (data-pc-variants),
     volby v pořadí "Materiál a provedení" / "Rám" / "Velikost";
   - názvy, barvy, profily a fotografie rámů = metaobjekty printseekers_ram (data-pc-frames),
     naplněné z oficiálního katalogu Printseekers. Nic se zde nevymýšlí ani nehardcoduje.

   Náhled zvoleného rámu se kreslí přímo do fotografie interiéru (data-pc-scene-frame);
   samostatný náhled pod konfigurátorem byl zrušen (2026-09-10 na přání majitelky).
   Volby v krocích 1–3 jsou kompaktní pilulky; popisek se ukáže až po kliknutí na „i“.

   Bez JavaScriptu zůstane ve formuláři přednastavená první dostupná varianta. */
(function () {
  'use strict';

  var root = document.querySelector('[data-configurator]');
  if (!root) return;

  function readJson(selector) {
    var el = root.querySelector(selector);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (err) {
      return null;
    }
  }

  var variants = readJson('[data-pc-variants]') || [];
  var catalog = readJson('[data-pc-frames]') || [];
  var cfg = readJson('[data-pc-config]') || {};
  var t = cfg.t || {};
  if (!variants.length) return;

  /* Kolik variant vykreslil Liquid živě, tedy s cenami v měně návštěvníka (max 250).
     Zbytek se níže doplní ze statické tabulky v korunách — ta je stejná pro všechny trhy,
     takže v eurech ukazovala nesmysly (410 Kč jako 410 €). Podle tohohle čísla se pozná,
     že se mají skutečné ceny dotáhnout ze Storefront API. */
  var liquidVariantCount = variants.length;

  /* Hodnota „bez rámu“ se bere z dat variant, ne z přeloženého popisku (oprava 2026-09-22).
     V jiných jazycích než česky je cfg.frameNone přeložené („Sin marco“, „Ohne Rahmen“),
     ale option2 ve variantách zůstává česky. Nespárovala se proto žádná varianta,
     nevykreslila se žádná velikost a produkt nešlo koupit. */
  var NONE = (function () {
    var chtene = cfg.frameNone;
    var pocty = {};
    var nejcastejsi = null;
    var nejvic = 0;
    for (var iN = 0; iN < variants.length; iN++) {
      var oN = variants[iN].option2;
      if (oN == null) continue;
      pocty[oN] = (pocty[oN] || 0) + 1;
      if (pocty[oN] > nejvic) { nejvic = pocty[oN]; nejcastejsi = oN; }
    }
    if (chtene && pocty[chtene]) return chtene;
    if (pocty['Bez rámu']) return 'Bez rámu';
    return nejcastejsi != null ? nejcastejsi : (chtene || 'Bez rámu');
  })();
  var hasSizeOption = (cfg.optionNames || []).length >= 3;
  var editionSoldOut = root.dataset.editionSoldOut === 'true';
  /* Edice se vztahuje jen na plátna (2026-09-13). Plakát z téhož díla se
     prodává dál i po vyprodání edice, proto se ptáme na zvolený materiál. */
  function editionBlocks() {
    return editionSoldOut && state.material === 'platno';
  }

  /* ------------------------------------------------------------------
     Klasifikace hodnot volby "Materiál a provedení"
     Text hodnoty je zdroj pravdy (obchodník ji může přejmenovat);
     odvozuje se jen materiál, zda je s rámem a zda jde o passepartout.
     ------------------------------------------------------------------ */
  function norm(s) {
    return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
  }

  /* Hodnota má tvar "Materiál · provedení[ · papír]". Třetí část (papír) se vybírá
     v samostatném kroku; první dvě části tvoří skupinu provedení (group). */
  function classify(value) {
    var n = norm(value);
    var parts = String(value || '').split('·').map(function (s) { return s.trim(); }).filter(Boolean);
    var material = n.indexOf('platno') === 0 ? 'platno' : 'poster';
    var pp = n.indexOf('passepartout') !== -1 || n.indexOf('paspart') !== -1;
    var framed;
    if (pp) {
      framed = true;
    } else if (n.indexOf('bez ram') !== -1) {
      framed = false;
    } else {
      framed = n.indexOf('ram') !== -1;
    }
    var line = material === 'platno' ? 'platno' : pp ? 'passepartout' : 'poster';
    var kind = material + (pp ? '_pp' : framed ? '_ram' : '_bez_ramu');
    var sub = '';
    if (material === 'platno') {
      if (n.indexOf('galerij') !== -1) sub = 'galerijni';
      else if (n.indexOf('rolovan') !== -1) sub = 'rolovane';
    }
    var key = kind + (sub ? '_' + sub : '');
    var group = parts.length > 2 ? parts.slice(0, 2).join(' · ') : value;
    var paper = parts.length > 2 ? parts.slice(2).join(' · ') : null;
    return { value: value, material: material, framed: framed, pp: pp, line: line, kind: kind, key: key, group: group, paper: paper };
  }

  var finishes = [];
  var materials = [];
  // Index provedení a materiálů z variant; volá se znovu po dohrání všech variant (loadAllVariants).
  function buildIndex() {
    finishes = [];
    variants.forEach(function (v) {
      if (!finishes.some(function (f) { return f.value === v.option1; })) {
        finishes.push(classify(v.option1));
      }
    });
    materials = [];
    ['platno', 'poster'].forEach(function (m) {
      if (finishes.some(function (f) { return f.material === m; })) materials.push(m);
    });
  }
  buildIndex();

  // Varianty nad 250 (Liquid je do stránky nedá) doplní metapole dilo.varianty: buď pole řádků
  // [id, materiál a provedení, rám, velikost, cena v haléřích, dostupné], nebo jen ID variant
  // (pole, nebo zkráceně {od, krok, n}) od pozice 251 – pak se zbytek řádku bere ze sdílené tabulky cfg.extraShared
  // (snippets/pc-variants-tail.liquid, stejná pro všechna díla daného poměru stran).
  // Cena/dostupnost prvních 250 variant se bere vždy živě z Liquidu.
  (function mergeExtraVariants() {
    var extra = cfg.extraVariants;
    // Zkrácený zápis {od, krok, n}: ID variant od pozice 251 jdou po pevném kroku (Shopify je
    // při importu přiděluje po 32768), takže stačí první ID, krok a počet.
    if (extra && !Array.isArray(extra) && extra.od) {
      var list = [];
      for (var k = 0; k < (Number(extra.n) || 0); k++) list.push(Number(extra.od) + k * (Number(extra.krok) || 32768));
      extra = list;
    }
    if (!extra || !extra.length) return;
    var shared = cfg.extraShared;
    var byId = {};
    variants.forEach(function (v) { byId[String(v.id)] = true; });
    var added = 0;
    extra.forEach(function (row, i) {
      if (!row) return;
      if (typeof row === 'number' || typeof row === 'string') {
        if (!shared || !shared[i]) return;
        row = [row].concat(shared[i]);
      }
      var o = Array.isArray(row)
        ? { id: row[0], option1: row[1], option2: row[2], option3: row[3], price: Number(row[4]) || 0, available: row[5] !== false && row[5] !== 0 }
        : row;
      if (o.id == null || byId[String(o.id)]) return;
      if (o.title == null) o.title = [o.option1, o.option2, o.option3].filter(Boolean).join(' / ');
      byId[String(o.id)] = true;
      variants.push(o);
      added += 1;
    });
    if (added) buildIndex();
  })();

  function finishByValue(value) {
    return finishes.filter(function (f) { return f.value === value; })[0] || null;
  }

  function finishesFor(material) {
    return finishes.filter(function (f) { return f.material === material; });
  }

  // Skupiny provedení (bez papíru) pro daný materiál; vrací první provedení každé skupiny.
  function groupsFor(material) {
    var seen = [];
    finishes.forEach(function (f) {
      if (f.material === material && !seen.some(function (g) { return g.group === f.group; })) seen.push(f);
    });
    return seen;
  }

  // Provedení (papíry) ve stejné skupině jako zadané provedení.
  function papersFor(finish) {
    if (!finish) return [];
    return finishes.filter(function (f) { return f.group === finish.group; });
  }

  // Výběr skupiny: zachová zvolený papír, pokud ho nová skupina má, jinak první provedení skupiny.
  function finishForGroup(group, current) {
    var inGroup = finishes.filter(function (f) { return f.group === group; });
    if (!inGroup.length) return null;
    if (current && current.paper) {
      var same = inGroup.filter(function (f) { return f.paper === current.paper; })[0];
      if (same) return same;
    }
    return inGroup[0];
  }

  function catalogEntry(finish, frameName) {
    if (!finish) return null;
    return catalog.filter(function (c) {
      return c.aktivni !== false && c.produkt === finish.line && c.nazev === frameName;
    })[0] || null;
  }

  function framesFor(finish) {
    var seen = [];
    variants.forEach(function (v) {
      if (v.option1 === finish.value && v.option2 !== NONE && v.option2 != null && seen.indexOf(v.option2) === -1) {
        seen.push(v.option2);
      }
    });
    // Pořadí podle katalogu (poradi), neznámé rámy nakonec v pořadí variant.
    return seen.sort(function (a, b) {
      var ca = catalogEntry(finish, a), cb = catalogEntry(finish, b);
      var pa = ca && ca.poradi != null ? ca.poradi : 9999;
      var pb = cb && cb.poradi != null ? cb.poradi : 9999;
      return pa - pb;
    });
  }

  function sizesFor(finish, frame) {
    if (!hasSizeOption) return [];
    var seen = [];
    variants.forEach(function (v) {
      if (v.option1 === finish.value && v.option2 === frame && v.option3 != null && seen.indexOf(v.option3) === -1) {
        seen.push(v.option3);
      }
    });
    return seen;
  }

  function findVariant(finish, frame, size) {
    if (!finish) return null;
    return variants.filter(function (v) {
      return v.option1 === finish.value && v.option2 === frame && (!hasSizeOption || v.option3 === size);
    })[0] || null;
  }

  /* ------------------------------------------------------------------
     Stav a jeho sladění po každé změně
     ------------------------------------------------------------------ */
  var state = { material: null, finish: null, frame: null, size: null };

  function msg(template, values) {
    return String(template || '').replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, key) {
      return values[key] != null ? values[key] : '';
    });
  }

  // Výchozí varianta bez volby v URL: první provedení bez rámu ve "výchozí" velikosti (cfg.defaultSize,
  // např. "60 × 90 cm"; když ji produkt nemá, velikost s delší stranou 90 cm), jinak první dostupná varianta.
  function defaultVariant() {
    var avail = variants.filter(function (x) { return x.available; });
    if (!avail.length) return variants[0];
    var firstFinish = finishes[0];
    var pool = avail.filter(function (x) { return !firstFinish || x.option1 === firstFinish.value; });
    if (!pool.length) pool = avail;
    var wanted = String(cfg.defaultSize || '');
    var hit = pool.filter(function (x) { return x.option2 === NONE && x.option3 === wanted; })[0];
    if (!hit) hit = pool.filter(function (x) { return x.option2 === NONE && /(^|\D)90(\D|$)/.test(String(x.option3 || '')); })[0];
    return hit || pool[0];
  }

  function initFromVariant(id) {
    var v = null;
    if (id) v = variants.filter(function (x) { return String(x.id) === String(id); })[0] || null;
    if (!v) v = defaultVariant();
    state.finish = finishByValue(v.option1);
    state.material = state.finish ? state.finish.material : materials[0];
    state.frame = v.option2 == null ? NONE : v.option2;
    state.size = v.option3 == null ? null : v.option3;
  }

  // Vrací seznam upozornění pro zákazníka (volby, které přestaly být dostupné).
  function reconcile() {
    var notices = [];

    var fins = finishesFor(state.material);
    if (!state.finish || state.finish.material !== state.material || fins.indexOf(state.finish) === -1) {
      var prevFinish = state.finish;
      state.finish = fins[0] || null;
      if (prevFinish && state.finish && prevFinish.material === state.material) {
        notices.push(msg(t.notice_reset, { old: prevFinish.value, 'new': state.finish.value }));
      }
    }
    if (!state.finish) return notices;

    if (state.finish.framed) {
      var frames = framesFor(state.finish);
      if (frames.indexOf(state.frame) === -1) {
        var prevFrame = state.frame;
        state.frame = frames[0] || null;
        if (prevFrame && prevFrame !== NONE && state.frame) {
          notices.push(msg(t.notice_reset, { old: prevFrame, 'new': state.frame }));
        }
      }
    } else {
      state.frame = NONE;
    }

    if (hasSizeOption) {
      var sizes = sizesFor(state.finish, state.frame);
      if (sizes.indexOf(state.size) === -1) {
        var prevSize = state.size;
        state.size = sizes[0] || null;
        if (prevSize && state.size) {
          notices.push(msg(t.notice_reset, { old: prevSize, 'new': state.size }));
        }
      }
    }
    return notices;
  }

  /* ------------------------------------------------------------------
     Peníze — formát obchodu (shop.money_format)
     ------------------------------------------------------------------ */
  function fixed(value, decimals, thousands, decimalSep) {
    var parts = Math.abs(value).toFixed(decimals).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return (value < 0 ? '-' : '') + parts.join(decimalSep);
  }

  function formatMoney(cents) {
    var value = cents / 100;
    var fmt = cfg.moneyFormat || '{{amount}}';
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return fixed(value, 0, ',', '.');
        case 'amount_with_comma_separator': return fixed(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fixed(value, 0, '.', ',');
        case 'amount_with_space_separator': return fixed(value, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return fixed(value, 0, ' ', ',');
        case 'amount_with_apostrophe_separator': return fixed(value, 2, "'", '.');
        default: return fixed(value, 2, ',', '.');
      }
    });
  }

  /* ------------------------------------------------------------------
     Vykreslení
     ------------------------------------------------------------------ */
  var lists = {
    material: root.querySelector('[data-pc-list="material"]'),
    finish: root.querySelector('[data-pc-list="finish"]'),
    paper: root.querySelector('[data-pc-list="paper"]'),
    frame: root.querySelector('[data-pc-list="frame"]'),
    size: root.querySelector('[data-pc-list="size"]')
  };
  var steps = {
    paper: root.querySelector('[data-pc-step="paper"]'),
    frame: root.querySelector('[data-pc-step="frame"]'),
    size: root.querySelector('[data-pc-step="size"]')
  };
  var finishNote = root.querySelector('[data-pc-finish-note]');
  var noticeEl = root.querySelector('[data-pc-notice]');
  var summaryEl = root.querySelector('[data-pc-summary]');
  var artEl = root.querySelector('[data-pc-art]');
  var artImg = artEl ? artEl.querySelector('img') : null;
  var previewNote = root.querySelector('[data-pc-preview-note]');

  // Vedlejší dlaždice s čistým motivem (fotka „-motiv“ vedle AI náhledu): obalí se do .pc-art,
  // takže se na ní kreslí zvolené provedení (rám z fotografie, plátno, papír) stejně jako ve scéně.
  function motifPath(u) {
    return String(u || '').replace(/^https?:/, '').split('?')[0];
  }

  // Hrany napnutého plátna (pohled zešikma jako na fotkách Printseekers): čtyři prvky kolem motivu,
  // otočené o 90° do hloubky, s motivem zrcadlově přetaženým přes okraj. Hloubka = 19 / 38 mm
  // v poměru k šířce tisku, stejně jako u rámů z fotografie. Odvrácené hrany se nekreslí
  // (backface-visibility), takže při natáčení zvětšeniny je vidět vždy správná strana.
  var artEdge = null;
  var EDGE_SIDES = ['right', 'left', 'top', 'bottom'];
  function makeCanvasEdge() {
    var edges = document.createElement('span');
    edges.className = 'pc-art-edges';
    edges.hidden = true;
    edges.setAttribute('aria-hidden', 'true');
    edges.innerHTML = EDGE_SIDES.map(function (side) {
      return '<span class="pc-art-edge pc-art-edge--' + side + '"><span class="pc-art-edge-img"></span></span>';
    }).join('');
    return edges;
  }

  function canvasDepthCm(f) {
    return f && f.key === 'platno_bez_ramu_galerijni' ? 3.8 : 1.9;
  }

  // Hloubka rámu (jak daleko lišta odstává od stěny). Printseekers ji u lišt neuvádí,
  // tohle je odhad podle profilu na jejich fotografiích: plovoucí rám na plátně je
  // znatelně hlubší než rám posteru s plexisklem. Až budou přesná čísla, patří do
  // metaobjektu printseekers_ram vedle sirka_cm a číst se budou odtud.
  function frameDepthCm(f) {
    return f && f.kind === 'platno_ram' ? 3.2 : 2.2;
  }

  // Zaoblení rohů napnutého plátna (Printseekers má rohy znatelně kulaté): ~3 % šířky, nejvýš 18 px.
  function canvasRadiusPx(faceWidthPx) {
    return Math.min(18, faceWidthPx * 0.03);
  }

  // Které hrany jsou vidět: při natočení kolem svislé osy doprava (ry < 0) pravá, doleva levá; při naklonění
  // (rx) spodní nebo horní. Hrana viděná přesně z boku se nekreslí (jinak zůstane tenká čára).
  function edgeSides(host, rx, ry) {
    if (!host) return;
    host.classList.toggle('pc-edge-r', ry < -2);
    host.classList.toggle('pc-edge-l', ry > 2);
    host.classList.toggle('pc-edge-b', rx > 2);
    host.classList.toggle('pc-edge-t', rx < -2);
  }
  function applyCanvasEdge(edgeEl, faceWidthPx, faceHeightPx) {
    if (!edgeEl) return;
    var f = state.finish;
    var host = edgeEl.parentNode;
    // dlaždice motivu je natočená napevno (rotateY -16°), zvětšení podle aktuálních úhlů
    if (host) edgeSides(host, host === zoomWrap ? zoomRot.x : 0, host === zoomWrap ? zoomRot.y : -16);
    var show = !!(f && f.kind === 'platno_bez_ramu' && f.key !== 'platno_bez_ramu_rolovane' && cfg.motif && faceWidthPx > 0);
    // Rám má hloubku taky (dřív ji měla jen plátna bez rámu, takže rámovaný obraz
    // se při natáčení choval jako placka). Kreslí se jen ve zvětšení: dlaždice
    // s motivem je u rámovaných provedení zpříma, bez perspektivy, a stěna otočená
    // o 90° by tam měla nulovou šířku.
    var ram = !!(f && f.framed && faceWidthPx > 0 && host && host === zoomWrap);
    edgeEl.classList.toggle('pc-art-edges--ram', ram);
    edgeEl.hidden = !(show || ram);
    if (!show && !ram) {
      if (host) host.style.removeProperty('--pc-radius');
      return;
    }
    if (ram) {
      // Stěny patří na VNĚJŠÍ obrys rámu, jenže absolutně umístěný prvek se měří od
      // vnitřní hrany rámečku. Odsazení ven = naměřená šířka rámečku; měřením sedí
      // fotorám (px z applyPhotoFrame) i jednobarevná lišta (px z CSS).
      var bs = getComputedStyle(host);
      edgeEl.style.setProperty('--pc-bw-t', bs.borderTopWidth || '0px');
      edgeEl.style.setProperty('--pc-bw-s', bs.borderLeftWidth || '0px');
      // Totéž na obal — podle toho se umístí stín na vnější obrys rámu.
      host.style.setProperty('--pc-bw-t', bs.borderTopWidth || '0px');
      host.style.setProperty('--pc-bw-s', bs.borderLeftWidth || '0px');
      edgeEl.style.setProperty('--pc-depth', (frameDepthCm(f) / printWidthCm() * faceWidthPx).toFixed(2) + 'px');
      // Bok rámu byl doteď jen plochá barva podle odstínu, takže při natočení byl
      // předek rám a bok barevný proužek (majitelka 2026-09-21). Teď se bere z vnější
      // hrany též fotky rámu, která kreslí předek — stejným způsobem, jakým se
      // u plátna bez rámu přetahuje motiv přes hranu. Rám bez fotky (jednobarevná
      // lišta) zůstává na barvě.
      //
      // `--pc-face` je VNĚJŠÍ rozměr rámu (offsetWidth už rámeček započítává), aby
      // pozadí sedělo na stejné měřítko jako předek a proužek u okraje byl opravdu
      // ta vnější hrana lišty.
      var ramImg = currentPf && currentPf.src;
      edgeEl.classList.toggle('pc-art-edges--foto', !!ramImg);
      if (ramImg) {
        edgeEl.style.setProperty('--pc-ram', 'url("' + ramImg + '")');
        edgeEl.style.setProperty('--pc-face', (host.offsetWidth || 0) + 'px');
        edgeEl.style.setProperty('--pc-face-h', (host.offsetHeight || 0) + 'px');
      }
      host.style.setProperty('--pc-radius', '0px');
      return;
    }
    edgeEl.classList.remove('pc-art-edges--foto');
    var d = canvasDepthCm(f) / printWidthCm() * faceWidthPx;
    edgeEl.style.setProperty('--pc-depth', d.toFixed(2) + 'px');
    edgeEl.style.setProperty('--pc-face', faceWidthPx + 'px');
    edgeEl.style.setProperty('--pc-face-h', (faceHeightPx > 0 ? faceHeightPx : faceWidthPx) + 'px');
    edgeEl.style.setProperty('--pc-motif', 'url("' + cfg.motif + '")');
    if (host) host.style.setProperty('--pc-radius', canvasRadiusPx(faceWidthPx).toFixed(1) + 'px');
  }
  if (!artEl && cfg.motif) {
    var motifKey = motifPath(cfg.motif);
    var tileImgs = document.querySelectorAll('.product-media .media-zoom--secondary img');
    for (var ti = 0; ti < tileImgs.length; ti++) {
      var srcAttr = tileImgs[ti].currentSrc || tileImgs[ti].getAttribute('src') || '';
      if (motifKey && motifPath(srcAttr) === motifKey) {
        var wrap = document.createElement('span');
        wrap.className = 'pc-art';
        wrap.setAttribute('data-pc-art', '');
        tileImgs[ti].parentNode.insertBefore(wrap, tileImgs[ti]);
        wrap.appendChild(tileImgs[ti]);
        artEdge = makeCanvasEdge();
        wrap.appendChild(artEdge);
        var tileBtn = wrap.closest('.media-zoom');
        if (tileBtn) tileBtn.classList.add('media-zoom--art');
        artEl = wrap;
        artImg = tileImgs[ti];
        break;
      }
    }
  }
  // Rám dokreslený do fotografie v interiéru (sections/signature-product.liquid, metapole dilo.scena_ram).
  var sceneEl = document.querySelector('[data-pc-scene-frame]');
  // Překreslování plátna a rámu do fotky interiéru je VYPNUTÉ (rozhodnutí majitelky 2026-09-12: v AI fotkách
  // se náhled v části pokojů rozpadal – jiné světlo, nábytek před obrazem). Fotka pokoje zůstává originál,
  // zvolené provedení a rám se ukazují jen na dlaždici motivu a v jejím zvětšení. Kód scény zůstává,
  // zapne se přepnutím SCENE_OVERLAY (metapole dilo.scena_ram jsou u všech děl dál vyplněná).
  var SCENE_OVERLAY = false;
  var scene = SCENE_OVERLAY && cfg.scene && typeof cfg.scene === 'object' ? cfg.scene : null;
  var currentPf = null;
  var currentEntry = null;

  // Vrstva „plátno / papír“ ve scéně: motiv přes celý obdélník scena_ram (překryje rám, který je
  // ve fotce vyfocený napevno), stín podle provedení, u plovoucího rámu mezera, u pasparty bílý okraj.
  // Vytváří se tady v JS, aby se nemusela měnit sekce stránky díla.
  var sceneCanvas = null;
  if (sceneEl && scene && cfg.motif) {
    sceneCanvas = document.createElement('span');
    sceneCanvas.className = 'pc-scene-canvas';
    sceneCanvas.hidden = true;
    sceneCanvas.setAttribute('aria-hidden', 'true');
    var sceneCanvasImg = document.createElement('img');
    sceneCanvasImg.alt = '';
    sceneCanvasImg.decoding = 'async';
    sceneCanvasImg.src = cfg.motif;
    sceneCanvas.appendChild(sceneCanvasImg);
    sceneEl.parentNode.insertBefore(sceneCanvas, sceneEl);
  }

  function placeInScene(node) {
    node.style.left = (Number(scene.x) * 100) + '%';
    node.style.top = (Number(scene.y) * 100) + '%';
    node.style.width = (Number(scene.w) * 100) + '%';
    node.style.height = (Number(scene.h) * 100) + '%';
  }

  // Popředí scény: nábytek, který je ve fotce před obrazem, se překreslí nad plátno i rám
  // (jinak by přes něj šel motiv a stín). Polygony v metapoli dilo.scena_ram.popredi jako pole
  // bodů [x, y] v poměru k celé fotce (0–1); víc polygonů = pole polí. Kreslí se kopií fotky
  // oříznutou přes clip-path, takže sedí na pixel v dlaždici i ve zvětšení.
  function foregroundPolygons() {
    var p = scene && scene.popredi;
    if (!p || !p.length) return [];
    if (p[0] && typeof p[0][0] === 'number') p = [p];
    return p.filter(function (poly) { return poly && poly.length >= 3; });
  }

  function makeForegrounds(host) {
    var list = [];
    if (!host) return list;
    foregroundPolygons().forEach(function (poly) {
      var fg = document.createElement('img');
      fg.className = 'pc-scene-fg';
      fg.alt = '';
      fg.hidden = true;
      fg.setAttribute('aria-hidden', 'true');
      fg.decoding = 'async';
      fg.style.clipPath = 'polygon(' + poly.map(function (pt) {
        return (Number(pt[0]) * 100).toFixed(2) + '% ' + (Number(pt[1]) * 100).toFixed(2) + '%';
      }).join(', ') + ')';
      host.appendChild(fg);
      list.push(fg);
    });
    return list;
  }

  function setForegrounds(list, src, srcset, sizes, visible) {
    list.forEach(function (fg) {
      if (src && fg.getAttribute('src') !== src) fg.setAttribute('src', src);
      if (srcset) fg.setAttribute('srcset', srcset); else fg.removeAttribute('srcset');
      if (sizes) fg.setAttribute('sizes', sizes); else fg.removeAttribute('sizes');
      fg.hidden = !visible;
    });
  }

  /* ------------------------------------------------------------------
     Zvětšení fotky (dialog #zoom-dialog, otevírá gallery.js): zvětšená fotka
     interiéru dostane stejné vrstvy (plátno + rám) jako dlaždice; zvětšený motiv
     dostane kolem sebe zvolené provedení jako vedlejší dlaždice.
     ------------------------------------------------------------------ */
  var zoomDialog = document.getElementById('zoom-dialog');
  var zoomStin = null;
  var zoomImg = document.getElementById('zoom-image');
  var zoomWrap = null;
  var zoomCanvas = null;
  var zoomFrame = null;
  var zoomEdge = null;
  var zoomMode = null;
  var zoomFgs = [];
  var zoomHint = null;
  // Natočení zvětšeného plátna (tažením myší / prstem); úhly jdou do CSS proměnných --pc-rx / --pc-ry.
  var zoomRot = { x: 0, y: -10 };
  var zoomDrag = null;
  var zoomSwallowClick = false;
  function setRotation(rx, ry) {
    zoomRot.x = Math.max(-30, Math.min(30, rx));
    zoomRot.y = Math.max(-65, Math.min(65, ry));
    if (!zoomWrap) return;
    zoomWrap.style.setProperty('--pc-rx', zoomRot.x.toFixed(1) + 'deg');
    zoomWrap.style.setProperty('--pc-ry', zoomRot.y.toFixed(1) + 'deg');
    edgeSides(zoomWrap, zoomRot.x, zoomRot.y);
  }
  if (zoomDialog && zoomImg && zoomImg.parentNode) {
    zoomWrap = document.createElement('span');
    zoomWrap.className = 'pc-zoom';
    zoomImg.parentNode.insertBefore(zoomWrap, zoomImg);
    zoomWrap.appendChild(zoomImg);
    zoomEdge = makeCanvasEdge();
    zoomWrap.appendChild(zoomEdge);
    // Stín na zeď: skutečný rám drží pár centimetrů od zdi, takže za ním je měkký stín
    // posunutý ve směru světla. Je uvnitř otočitelného obalu, takže se natáčí s ním,
    // a záporný translateZ ho posadí dozadu do roviny zdi (majitelka 2026-09-22:
    // „fotka od Printseekers vypadá reálněji“).
    zoomStin = document.createElement('span');
    zoomStin.className = 'pc-zoom-stin';
    zoomStin.setAttribute('aria-hidden', 'true');
    zoomWrap.appendChild(zoomStin);
    if (scene && cfg.motif) {
      zoomCanvas = document.createElement('span');
      zoomCanvas.className = 'pc-scene-canvas';
      zoomCanvas.hidden = true;
      zoomCanvas.setAttribute('aria-hidden', 'true');
      var zoomCanvasImg = document.createElement('img');
      zoomCanvasImg.alt = '';
      zoomCanvasImg.src = cfg.motif;
      zoomCanvas.appendChild(zoomCanvasImg);
      zoomFrame = document.createElement('span');
      zoomFrame.className = 'pc-scene-frame';
      zoomFrame.hidden = true;
      zoomFrame.setAttribute('aria-hidden', 'true');
      zoomWrap.appendChild(zoomCanvas);
      zoomWrap.appendChild(zoomFrame);
      zoomFgs = makeForegrounds(zoomWrap);
    }
    // Která dlaždice se zvětšuje (scéna, nebo motiv) – zjistí se z kliknutí dřív, než gallery.js otevře dialog.
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-zoom-src]');
      if (!b) return;
      if (b.querySelector('[data-pc-scene]')) zoomMode = 'scene';
      else if (artEl && b.contains(artEl)) zoomMode = 'art';
      else zoomMode = null;
    }, true);
    // Po otevření (gallery.js nastaví src a otevře dialog) překreslit hned, po načtení obrázku znovu (přesná šířka).
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-zoom-src]')) setTimeout(renderZoom, 0);
    });
    zoomImg.addEventListener('load', function () { renderZoom(); });
    zoomDialog.addEventListener('close', function () { zoomMode = null; renderZoom(); });
    // Některé prohlížeče/webview událost „close“ nevyvolají – hlídá se i atribut open.
    if (typeof MutationObserver === 'function') {
      new MutationObserver(function () {
        if (!zoomDialog.open) { zoomMode = null; renderZoom(); }
      }).observe(zoomDialog, { attributes: true, attributeFilter: ['open'] });
    }

    // Natáčení zvětšeného plátna (na přání majitelky): tažením myší nebo prstem se plátno otáčí,
    // aby si zákazník prohlédl hrany z různých úhlů. Nápověda se ukáže jen u napnutého plátna.
    zoomHint = document.createElement('span');
    zoomHint.className = 'pc-zoom-hint';
    zoomHint.hidden = true;
    zoomHint.textContent = t.rotate_hint || '';
    zoomDialog.appendChild(zoomHint);
    zoomWrap.addEventListener('pointerdown', function (e) {
      if (!zoomWrap.classList.contains('pc-zoom--rotatable') || e.button > 0) return;
      zoomDrag = { x: e.clientX, y: e.clientY, rx: zoomRot.x, ry: zoomRot.y, moved: false };
      zoomWrap.classList.add('is-dragging');
      try { zoomWrap.setPointerCapture(e.pointerId); } catch (err) { /* starší prohlížeče */ }
      e.preventDefault();
    });
    zoomWrap.addEventListener('pointermove', function (e) {
      if (!zoomDrag) return;
      var dx = e.clientX - zoomDrag.x;
      var dy = e.clientY - zoomDrag.y;
      if (Math.abs(dx) + Math.abs(dy) > 3) zoomDrag.moved = true;
      setRotation(zoomDrag.rx - dy * 0.25, zoomDrag.ry + dx * 0.35);
    });
    function endZoomDrag() {
      if (!zoomDrag) return;
      zoomSwallowClick = zoomDrag.moved;
      zoomDrag = null;
      zoomWrap.classList.remove('is-dragging');
      setTimeout(function () { zoomSwallowClick = false; }, 0);
    }
    zoomWrap.addEventListener('pointerup', endZoomDrag);
    zoomWrap.addEventListener('pointercancel', endZoomDrag);
    // Kliknutí, kterým skončilo tažení, nesmí zavřít dialog (gallery.js zavírá při kliknutí mimo obrázek).
    zoomDialog.addEventListener('click', function (e) {
      if (zoomSwallowClick) {
        e.stopImmediatePropagation();
        e.preventDefault();
      }
    }, true);
  }

  function renderZoom() {
    if (!zoomWrap) return;
    var open = !!zoomDialog.open && zoomImg.getAttribute('src');
    var artMode = !!(open && zoomMode === 'art' && artEl);
    if (artMode) {
      zoomWrap.className = 'pc-zoom ' + artEl.className;
      zoomWrap.style.setProperty('--frame', artEl.style.getPropertyValue('--frame') || '#2a2825');
      // Velikost motivu ve zvětšení: gallery.css omezuje jen <img> (96vw × 92vh), ale kolem něj přibude rám
      // z fotografie a případně pasparta. Obrázek se proto nastaví napevno v px tak, aby se celý obal
      // (motiv + rám + pasparta) vešel do 94 % šířky a 90 % výšky okna – dvakrát: nejdřív odhad, pak
      // změření obalu a přepočet (rám je úměrný šířce motivu, takže druhý průchod sedí).
      var nw = zoomImg.naturalWidth || 1, nh = zoomImg.naturalHeight || 1;
      var maxW = Math.max(200, window.innerWidth * 0.94), maxH = Math.max(200, window.innerHeight * 0.90);
      zoomImg.style.maxWidth = 'none';
      zoomImg.style.maxHeight = 'none';
      var w0 = Math.min(maxW, maxH * nw / nh);
      // Pasparta: configurator.css ji dělá jako `padding: 11%`. Procenta se ale v CSS počítají ze
      // šířky RODIČE, a tím je tady dialog zvětšení, ne motiv. Ve zvětšení proto pasparta vyrostla
      // do stovek pixelů, smyčka níže kvůli tomu pořád zmenšovala motiv — a výsledek byl malý obrázek
      // uprostřed obrovské bílé plochy (majitelka 2026-09-21). Nastavuje se proto napevno v px ze
      // šířky motivu, stejně jako rám. Poměr 11/78 je převod z CSS: v rámečku zabírá motiv 78 %
      // šířky a pasparta 11 % na každé straně, takže zvětšení vypadá stejně jako malý náhled.
      var maPaspartu = zoomWrap.className.indexOf('pc-art--poster-pp') !== -1;
      for (var pass = 0; pass < 2; pass++) {
        zoomImg.style.width = Math.round(w0) + 'px';
        zoomImg.style.height = Math.round(w0 * nh / nw) + 'px';
        zoomWrap.style.padding = maPaspartu ? (Math.round(w0) * 11 / 78).toFixed(1) + 'px' : '';
        applyPhotoFrame(zoomWrap, currentPf, Math.round(w0), printWidthCm());
        var ow = zoomWrap.offsetWidth || 1, oh = zoomWrap.offsetHeight || 1;
        var sc = Math.min(maxW / ow, maxH / oh);
        if (sc >= 0.995) break;
        w0 = Math.floor(w0 * sc);
      }
      applyCanvasEdge(zoomEdge, zoomImg.clientWidth, zoomImg.clientHeight);
    } else {
      zoomWrap.className = 'pc-zoom';
      zoomWrap.style.padding = '';
      zoomWrap.style.removeProperty('--frame');
      zoomWrap.style.removeProperty('--pc-radius');
      zoomImg.style.width = '';
      zoomImg.style.height = '';
      zoomImg.style.maxWidth = '';
      zoomImg.style.maxHeight = '';
      applyPhotoFrame(zoomWrap, null);
      if (zoomEdge) zoomEdge.hidden = true;
    }
    // Natáčet jde každé provedení motivu (majitelka 2026-09-12); po zavření se úhel vrátí na výchozí.
    // Světlé pozadí jen u náhledu díla: rám se fotí na světlé zdi a proti černému
    // pozadí nemá kam vrhnout stín. Zvětšená fotka pokoje zůstává na tmavém.
    zoomDialog.classList.toggle('zoom--dilo', artMode);
    var canRotate = artMode;
    zoomWrap.classList.toggle('pc-zoom--rotatable', canRotate);
    if (zoomHint) zoomHint.hidden = !canRotate || !zoomHint.textContent;
    if (!canRotate) setRotation(0, -10);
    if (zoomCanvas && zoomFrame) {
      if (open && zoomMode === 'scene') {
        renderSceneInto(zoomCanvas, zoomFrame, currentPf, currentEntry);
        setForegrounds(zoomFgs, zoomImg.getAttribute('src'), null, null, true);
      } else {
        zoomCanvas.hidden = true;
        zoomFrame.hidden = true;
        setForegrounds(zoomFgs, null, null, null, false);
      }
    }
  }

  /* ------------------------------------------------------------------
     Rám z fotografie (CSS border-image)
     Metaobjekt rámu nese složený obrázek (obrazek_css), tloušťku lišty
     v pixelech obrázku (rez_horni, rez_pravy) a odhad šířky lišty v cm
     (sirka_cm). Tloušťka v náhledu = sirka_cm / šířka tisku v cm × šířka
     motivu v px, takže rám má vůči obrazu správný poměr.
     ------------------------------------------------------------------ */
  function photoFrame(entry) {
    if (!entry || !entry.css_img) return null;
    var top = Number(entry.rez_horni), right = Number(entry.rez_pravy), cm = Number(entry.sirka_cm);
    if (!(top > 0) || !(right > 0) || !(cm > 0)) return null;
    return { src: entry.css_img, top: top, right: right, cm: cm };
  }

  // Šířka tisku v cm ze zvolené velikosti ("60 × 90 cm" → 60); bez velikosti první dostupná, jinak 60.
  function printWidthCm() {
    var s = state.size;
    if (!s && state.finish) { var sizes = sizesFor(state.finish, state.frame); s = sizes[0]; }
    var m = /(\d+(?:[.,]\d+)?)/.exec(String(s || ''));
    var w = m ? parseFloat(m[1].replace(',', '.')) : 0;
    return w > 0 ? w : 60;
  }

  function applyPhotoFrame(target, pf, innerWidthPx, widthCm) {
    if (!target) return;
    if (!pf || !(innerWidthPx > 0) || !(widthCm > 0)) {
      target.style.borderImageSource = '';
      target.style.borderImageSlice = '';
      target.style.borderWidth = '';
      return;
    }
    var wTop = pf.cm / widthCm * innerWidthPx;
    var wSide = wTop * pf.right / pf.top;
    target.style.borderImageSource = 'url("' + pf.src + '")';
    target.style.borderImageSlice = pf.top + ' ' + pf.right;
    target.style.borderWidth = wTop.toFixed(2) + 'px ' + wSide.toFixed(2) + 'px';
  }

  // Vrstvy scény do zadaných prvků (dlaždice nebo zvětšený dialog):
  // canvasNode = motiv/plátno přes obdélník scena_ram, frameNode = rám.
  // pf = rám z fotografie (nebo null), entry = katalogový záznam zvoleného rámu (barva/šířka bez fotky).
  function renderSceneInto(canvasNode, frameNode, pf, entry) {
    if (!scene) return;
    var f = state.finish;
    var cm = Number(scene.sirka_cm) > 0 ? Number(scene.sirka_cm) : 100;
    var framed = !!(f && f.framed);
    if (canvasNode) {
      var cls = ['pc-scene-canvas'];
      if (f) cls.push('pc-scene-canvas--' + f.kind.replace(/_/g, '-'));
      if (f && f.key !== f.kind) cls.push('pc-scene-canvas--' + f.key.replace(/_/g, '-'));
      cls.push(framed ? 'pc-scene-canvas--framed' : 'pc-scene-canvas--plain');
      canvasNode.className = cls.join(' ');
      placeInScene(canvasNode);
      canvasNode.hidden = false;
      // Okraje v poměru k šířce obrazu ve scéně: pasparta ~9 %, mezera plovoucího rámu ~1,2 %.
      var w = canvasNode.offsetWidth;
      if (f && f.pp) canvasNode.style.padding = (0.09 * w).toFixed(1) + 'px';
      else if (f && f.kind === 'platno_ram') canvasNode.style.padding = (0.012 * w).toFixed(1) + 'px';
      else canvasNode.style.padding = '';
      applySceneEdge(canvasNode, f, w, cm);
    }
    if (!frameNode) return;
    if (!framed) {
      frameNode.hidden = true;
      applyPhotoFrame(frameNode, null);
      frameNode.style.borderColor = '';
      return;
    }
    frameNode.hidden = false;
    placeInScene(frameNode);
    if (pf) {
      frameNode.style.borderColor = 'transparent';
      applyPhotoFrame(frameNode, pf, frameNode.offsetWidth, cm);
    } else {
      // Rám bez fotografie: jednobarevná lišta v odstínu z katalogu, šířka podle katalogu (výchozí 2 cm).
      applyPhotoFrame(frameNode, null);
      var wcm = entry && Number(entry.sirka_cm) > 0 ? Number(entry.sirka_cm) : 2;
      frameNode.style.borderColor = entry && entry.odstin ? entry.odstin : '#2a2825';
      frameNode.style.borderWidth = (wcm / cm * frameNode.offsetWidth).toFixed(2) + 'px';
    }
  }

  // Napnuté plátno ve fotce interiéru: kulaté rohy a pravá + spodní hrana s přetaženým motivem
  // (fotka je zpředu, takže hrany jsou úzké: 19 / 38 mm v poměru k šířce obrazu ve scéně, spodní
  // o něco kratší). Prvek .pc-scene-edges se vytvoří napoprvé a dál se jen přepíná a přepočítává.
  function applySceneEdge(canvasNode, f, w, cm) {
    var edges = canvasNode.querySelector('.pc-scene-edges');
    var show = !!(f && f.kind === 'platno_bez_ramu' && f.key !== 'platno_bez_ramu_rolovane' && cfg.motif && w > 0);
    if (!show) {
      if (edges) edges.hidden = true;
      canvasNode.style.removeProperty('--pc-radius');
      return;
    }
    if (!edges) {
      edges = document.createElement('span');
      edges.className = 'pc-scene-edges';
      edges.setAttribute('aria-hidden', 'true');
      edges.innerHTML = ['right', 'bottom'].map(function (side) {
        return '<span class="pc-scene-edge pc-scene-edge--' + side + '"><span class="pc-scene-edge-img"></span></span>';
      }).join('');
      canvasNode.appendChild(edges);
    }
    var h = canvasNode.offsetHeight;
    var d = canvasDepthCm(f) / cm * w;
    edges.style.setProperty('--pc-depth', d.toFixed(2) + 'px');
    edges.style.setProperty('--pc-depth-b', (d * 0.6).toFixed(2) + 'px');
    edges.style.setProperty('--pc-face', w + 'px');
    edges.style.setProperty('--pc-face-h', (h > 0 ? h : w) + 'px');
    edges.style.setProperty('--pc-motif', 'url("' + cfg.motif + '")');
    canvasNode.style.setProperty('--pc-radius', canvasRadiusPx(w).toFixed(1) + 'px');
    edges.hidden = false;
  }

  function renderScene(pf, entry) {
    if (!sceneEl || !scene) return;
    renderSceneInto(sceneCanvas, sceneEl, pf, entry);
  }

  // Přepočet tloušťky rámu po načtení obrázků a změně velikosti okna.
  function refreshFrames() {
    if (artEl) applyPhotoFrame(artEl, currentPf, artImg ? artImg.clientWidth : 0, printWidthCm());
    applyCanvasEdge(artEdge, artImg ? artImg.clientWidth : 0, artImg ? artImg.clientHeight : 0);
    renderScene(currentPf, currentEntry);
    renderZoom();
  }
  // Výška lepící hlavičky (.site-topbar) pro sloupec s fotkami přilepený při scrollování (configurator.css).
  function setTopbarVar() {
    var tb = document.querySelector('.site-topbar');
    if (tb) document.documentElement.style.setProperty('--pc-topbar', tb.offsetHeight + 'px');
  }
  setTopbarVar();
  var resizeTimer = null;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () { setTopbarVar(); refreshFrames(); }, 120);
  });
  if (artImg) artImg.addEventListener('load', refreshFrames);
  var sceneImg = sceneEl && sceneEl.parentNode ? sceneEl.parentNode.querySelector('img') : null;
  if (sceneImg) sceneImg.addEventListener('load', refreshFrames);
  // Popředí (nábytek před obrazem) v dlaždici scény: stejná fotka, stejné srcset/sizes, oříznutá polygonem.
  if (sceneImg && scene) {
    setForegrounds(makeForegrounds(sceneEl.parentNode), sceneImg.getAttribute('src'), sceneImg.getAttribute('srcset'), sceneImg.getAttribute('sizes'), true);
  }

  // Prvky mimo konfigurátor (formulář produktu) — stejné háčky jako původní výběr provedení.
  var idInput = document.querySelector('[data-variant-id]');
  var priceEl = document.querySelector('[data-price]');
  var button = document.getElementById('add-to-cart');
  var label = document.querySelector('[data-add-label]');
  var variantTitle = document.querySelector('[data-variant-title]');
  // „Koupit hned“ (sekce signature-product): trvalý odkaz košíku /cart/ID:počet vede rovnou do pokladny.
  var buyNow = document.querySelector('[data-buy-now]');
  var qtyInput = document.getElementById('quantity');
  function updateBuyNow(variant, canBuy) {
    if (!buyNow) return;
    if (variant && canBuy) {
      var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
      if (!(qty > 0)) qty = 1;
      buyNow.setAttribute('href', (buyNow.dataset.cartUrl || '/cart') + '/' + variant.id + ':' + qty);
      buyNow.removeAttribute('aria-disabled');
      buyNow.removeAttribute('tabindex');
    } else {
      buyNow.removeAttribute('href');
      buyNow.setAttribute('aria-disabled', 'true');
      buyNow.setAttribute('tabindex', '-1');
    }
  }
  if (qtyInput && buyNow) {
    ['input', 'change'].forEach(function (evt) {
      qtyInput.addEventListener(evt, function () {
        var v = findVariant(state.finish, state.frame, state.size);
        updateBuyNow(v, !!v && !!v.available && !editionBlocks());
      });
    });
  }

  function el(tag, className, html) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (html != null) node.innerHTML = html;
    return node;
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function card(opts) {
    var b = el('button', 'pc-card' + (opts.selected ? ' is-selected' : '') + (opts.extraClass ? ' ' + opts.extraClass : ''));
    b.type = 'button';
    b.setAttribute('aria-pressed', opts.selected ? 'true' : 'false');
    b.dataset[opts.dataKey] = opts.value;
    var html = '';
    if (opts.media) html += opts.media;
    html += '<span class="pc-card-body"><span class="pc-card-title">' + escapeHtml(opts.title) + '</span>';
    if (opts.meta) html += '<span class="pc-card-meta">' + opts.meta + '</span>';
    if (opts.price) html += '<span class="pc-card-price">' + escapeHtml(opts.price) + '</span>';
    html += '</span>';
    html += '<span class="pc-check" aria-hidden="true">✓</span>';
    html += '<span class="visually-hidden" data-pc-selected-text>' + (opts.selected ? escapeHtml(t.selected || '') : '') + '</span>';
    b.innerHTML = html;
    return b;
  }

  // Kompaktní volba (kroky 1–3): pilulka pro výběr + tlačítko „i“; popisek se ukáže
  // pod řádkem voleb daného kroku až na vyžádání (prvek [data-pc-info-text] ve fieldsetu).
  function chip(opts) {
    var wrap = el('span', 'pc-choice' + (opts.info ? '' : ' pc-choice--plain'));
    var b = el('button', 'option-pill pc-chip' + (opts.selected ? ' selected' : ''));
    b.type = 'button';
    b.setAttribute('aria-pressed', opts.selected ? 'true' : 'false');
    b.dataset[opts.dataKey] = opts.value;
    b.innerHTML = '<span class="pc-chip-title">' + escapeHtml(opts.title) + '</span>' +
      '<span class="visually-hidden" data-pc-selected-text>' + (opts.selected ? escapeHtml(t.selected || '') : '') + '</span>';
    wrap.appendChild(b);
    if (opts.info) {
      var i = el('button', 'pc-info');
      i.type = 'button';
      i.dataset.pcInfo = opts.step;
      i.dataset.pcTitle = opts.title;
      i.dataset.pcDesc = opts.info;
      i.setAttribute('aria-expanded', 'false');
      i.setAttribute('aria-label', (t.info_label || 'Info') + ': ' + opts.title);
      i.innerHTML = '<span aria-hidden="true">i</span>';
      wrap.appendChild(i);
    }
    return wrap;
  }

  function infoTextEl(step) {
    var fs = root.querySelector('[data-pc-step="' + step + '"]');
    return fs ? fs.querySelector('[data-pc-info-text]') : null;
  }

  function closeInfo(step) {
    var p = infoTextEl(step);
    if (p) {
      p.hidden = true;
      p.innerHTML = '';
    }
    var fs = root.querySelector('[data-pc-step="' + step + '"]');
    if (fs) {
      Array.prototype.forEach.call(fs.querySelectorAll('[data-pc-info]'), function (b) {
        b.setAttribute('aria-expanded', 'false');
      });
    }
  }

  function toggleInfo(btn) {
    var step = btn.dataset.pcInfo;
    var p = infoTextEl(step);
    if (!p) return;
    var wasOpen = btn.getAttribute('aria-expanded') === 'true';
    closeInfo(step);
    if (wasOpen) return;
    p.innerHTML = '<b>' + escapeHtml(btn.dataset.pcTitle) + '</b>' + escapeHtml(btn.dataset.pcDesc);
    p.hidden = false;
    btn.setAttribute('aria-expanded', 'true');
  }

  function materialLabel(m) {
    return m === 'platno' ? (t.material_platno || 'Plátno') : (t.material_poster || 'Poster');
  }

  function materialDesc(m) {
    return m === 'platno' ? (t.material_platno_desc || '') : (t.material_poster_desc || '');
  }

  function finishDesc(finish) {
    var d = cfg.finishDesc && typeof cfg.finishDesc === 'object' ? cfg.finishDesc : {};
    return d[finish.key] || t['finish_desc_' + finish.key] || d[finish.kind] || t['finish_desc_' + finish.kind] || '';
  }

  function paperDesc(finish) {
    var d = cfg.paperDesc && typeof cfg.paperDesc === 'object' ? cfg.paperDesc : {};
    return finish.paper ? (d[finish.paper] || '') : '';
  }

  // Titulek karty provedení bez prefixu materiálu ("Plátno · napnuté bez rámu" → "napnuté bez rámu").
  function groupTitle(finish) {
    var parts = String(finish.group || '').split('·').map(function (s) { return s.trim(); }).filter(Boolean);
    var title = parts.length > 1 ? parts.slice(1).join(' · ') : finish.group;
    return title.charAt(0).toUpperCase() + title.slice(1);
  }

  // Přečísluje viditelné kroky (skryté kroky se nepočítají).
  function renumberSteps() {
    var n = 0;
    Array.prototype.forEach.call(root.querySelectorAll('[data-pc-step]'), function (step) {
      if (step.hidden) return;
      n += 1;
      var b = step.querySelector('.pc-legend b');
      if (b) b.textContent = String(n);
    });
  }

  function renderMaterials() {
    if (!lists.material) return;
    lists.material.innerHTML = '';
    closeInfo('material');
    materials.forEach(function (m) {
      lists.material.appendChild(chip({
        step: 'material', dataKey: 'pcMaterial', value: m, title: materialLabel(m), info: materialDesc(m),
        selected: state.material === m
      }));
    });
  }

  function renderFinishes() {
    if (!lists.finish) return;
    lists.finish.innerHTML = '';
    closeInfo('finish');
    groupsFor(state.material).forEach(function (f) {
      lists.finish.appendChild(chip({
        step: 'finish', dataKey: 'pcFinish', value: f.group, title: groupTitle(f), info: finishDesc(f),
        selected: !!state.finish && state.finish.group === f.group
      }));
    });
    // Poznámka pod provedením (locales note_*) se už nezobrazuje – popisky jsou jen pod tlačítkem „i“.
    if (finishNote) {
      finishNote.textContent = '';
      finishNote.hidden = true;
    }
  }

  // Krok "Papír": jen když má zvolená skupina provedení víc než jednu variantu papíru.
  function renderPapers() {
    if (!lists.paper || !steps.paper) return;
    var papers = state.finish ? papersFor(state.finish) : [];
    var show = papers.length > 1;
    steps.paper.hidden = !show;
    lists.paper.innerHTML = '';
    closeInfo('paper');
    if (!show) return;
    papers.forEach(function (f) {
      lists.paper.appendChild(chip({
        step: 'paper', dataKey: 'pcPaper', value: f.value, title: f.paper, info: paperDesc(f),
        selected: state.finish === f
      }));
    });
  }

  // Dlaždice rámů: jen fotografie a název. Cena se u jednotlivých voleb nezobrazuje,
  // výsledná cena zvolené kombinace je vždy nahoře u názvu díla.
  function renderFrames() {
    if (!lists.frame || !steps.frame) return;
    var framed = !!(state.finish && state.finish.framed);
    steps.frame.hidden = !framed;
    lists.frame.innerHTML = '';
    if (!framed) return;

    var frames = framesFor(state.finish);

    frames.forEach(function (name) {
      var entry = catalogEntry(state.finish, name);
      var media;
      if (entry && entry.img) {
        var ratioStyle = entry.img_w && entry.img_h ? ' style="aspect-ratio:' + entry.img_w + '/' + entry.img_h + '"' : '';
        media = '<span class="pc-frame-media"' + ratioStyle + '><img src="' + escapeHtml(entry.img) + '" alt="' +
          escapeHtml(msg(t.frame_photo_alt, { name: name })) + '" loading="lazy" decoding="async"' +
          (entry.img_w ? ' width="' + entry.img_w + '" height="' + entry.img_h + '"' : '') + '></span>';
      } else {
        media = '<span class="pc-frame-media pc-frame-media--missing"><span>' + escapeHtml(t.frame_photo_missing || '') + '</span></span>';
      }
      var metaParts = [];
      if (entry && entry.barva) metaParts.push(escapeHtml(entry.barva));
      if (entry && entry.material) metaParts.push(escapeHtml(entry.material));
      if (entry && entry.img_typ === 'produktova_fotografie') metaParts.push('<em>' + escapeHtml(t.frame_photo_product || '') + '</em>');

      lists.frame.appendChild(card({
        dataKey: 'pcFrame', value: name, title: name, meta: metaParts.join(' · '), media: media,
        selected: state.frame === name, extraClass: 'pc-card--frame'
      }));
    });
  }

  function renderSizes() {
    if (!lists.size || !steps.size) return;
    steps.size.hidden = !hasSizeOption;
    lists.size.innerHTML = '';
    if (!hasSizeOption || !state.finish) return;
    var sizes = sizesFor(state.finish, state.frame);
    if (!sizes.length) {
      lists.size.appendChild(el('p', 'pc-empty', escapeHtml(t.size_none || '')));
      return;
    }
    sizes.forEach(function (s) {
      var v = findVariant(state.finish, state.frame, s);
      var b = el('button', 'option-pill pc-size' + (state.size === s ? ' selected' : '') + (v && !v.available ? ' is-unavailable' : ''));
      b.type = 'button';
      b.dataset.pcSize = s;
      b.setAttribute('aria-pressed', state.size === s ? 'true' : 'false');
      // Rozměr + konečná cena dané velikosti (majitelka chce ceny u velikostí ponechat).
      var html = '<span class="pc-size-label">' + escapeHtml(s) + '</span>';
      if (v && Number(v.price) > 0) html += '<span class="pc-size-price">' + escapeHtml(formatMoney(Number(v.price))) + '</span>';
      b.innerHTML = html;
      lists.size.appendChild(b);
    });
  }

  // Náhled: rám z fotografie se kreslí do fotky interiéru (renderScene) a – pokud je na stránce
  // samostatný náhled [data-pc-art] – i kolem motivu. Bez [data-pc-art] se kreslí jen scéna.
  function renderPreview(variant) {
    var f = state.finish;
    var entry = f && f.framed ? catalogEntry(f, state.frame) : null;
    var photo = variant && variant.featured_image && variant.featured_image.src;
    // Rám z fotografie jen u provedení s rámem; v samostatném náhledu jen bez skutečné fotografie varianty.
    var pf = f && f.framed && !(artEl && photo) ? photoFrame(entry) : null;
    if (artEl) {
      var classes = ['pc-art'];
      if (f) classes.push('pc-art--' + f.kind.replace(/_/g, '-'));
      if (f && f.key !== f.kind) classes.push('pc-art--' + f.key.replace(/_/g, '-'));
      if (pf) classes.push('pc-art--photo-frame');
      artEl.className = classes.join(' ');
      artEl.style.setProperty('--frame', entry && entry.odstin ? entry.odstin : '#2a2825');
      if (entry && entry.img) {
        artEl.style.setProperty('--frame-photo', 'url("' + entry.img + '")');
        artEl.classList.add('pc-art--has-photo');
      } else {
        artEl.style.removeProperty('--frame-photo');
      }
      if (artImg) {
        if (photo) {
          artImg.src = photo;
          artEl.classList.add('pc-art--photo');
        } else if (cfg.motif) {
          if (artImg.getAttribute('src') !== cfg.motif) artImg.src = cfg.motif;
          artEl.classList.remove('pc-art--photo');
        }
      }
    }
    currentPf = pf;
    currentEntry = entry;
    refreshFrames();
    if (previewNote) {
      var note;
      if (pf) note = t.preview_note_photo || t.preview_note || '';
      else if (entry && !entry.img) note = t.preview_note_no_photo || t.preview_note || '';
      else note = t.preview_note || '';
      previewNote.textContent = note;
    }
    if (summaryEl) {
      var parts = [];
      if (f) parts.push(materialLabel(f.material));
      if (f) parts.push(f.value);
      if (f && f.framed && state.frame) parts.push(state.frame);
      if (state.size) parts.push(state.size);
      summaryEl.textContent = parts.join(' · ');
    }
  }

  function showNotices(notices) {
    if (!noticeEl) return;
    if (!notices.length) {
      noticeEl.hidden = true;
      noticeEl.textContent = '';
      return;
    }
    noticeEl.textContent = notices.join(' ');
    noticeEl.hidden = false;
  }

  function applyVariant(variant) {
    var canBuy = !!variant && !!variant.available && !editionBlocks();
    if (idInput) idInput.value = variant ? variant.id : '';
    updateBuyNow(variant, canBuy);
    if (priceEl) {
      if (variant && Number(variant.price) > 0) {
        priceEl.textContent = formatMoney(Number(variant.price));
      } else {
        priceEl.textContent = priceEl.dataset.onRequest || t.price_on_request || priceEl.textContent;
      }
    }
    if (variantTitle && variant) variantTitle.textContent = variant.title;
    if (button) {
      button.disabled = !canBuy;
      if (label && button.dataset.labelAvailable && button.dataset.labelUnavailable) {
        label.textContent = canBuy ? button.dataset.labelAvailable : button.dataset.labelUnavailable;
      }
    }
    root.classList.toggle('pc--unavailable', !variant);
    var unavailable = root.querySelector('[data-pc-unavailable]');
    if (unavailable) unavailable.hidden = !!variant;
    if (variant && window.history && window.history.replaceState) {
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      } catch (err) { /* ignorovat */ }
    }
  }

  function render(notices) {
    renderMaterials();
    renderFinishes();
    renderPapers();
    renderFrames();
    renderSizes();
    renumberSteps();
    var variant = findVariant(state.finish, state.frame, state.size);
    renderPreview(variant);
    applyVariant(variant);
    showNotices(notices || []);
    root.dispatchEvent(new CustomEvent('configurator:change', { detail: { state: state, variant: variant } }));
  }

  /* ------------------------------------------------------------------
     Interakce
     ------------------------------------------------------------------ */
  root.addEventListener('click', function (e) {
    var info = e.target.closest('[data-pc-info]');
    if (info && root.contains(info)) {
      e.preventDefault();
      toggleInfo(info);
      return;
    }
    var target = e.target.closest('[data-pc-material],[data-pc-finish],[data-pc-paper],[data-pc-frame],[data-pc-size]');
    if (!target || !root.contains(target)) return;
    e.preventDefault();
    var ds = target.dataset;
    if (ds.pcMaterial != null) {
      if (state.material === ds.pcMaterial) return;
      state.material = ds.pcMaterial;
    } else if (ds.pcFinish != null) {
      var f = finishForGroup(ds.pcFinish, state.finish) || finishByValue(ds.pcFinish);
      if (!f || f === state.finish) return;
      state.finish = f;
      state.material = f.material;
    } else if (ds.pcPaper != null) {
      var pf = finishByValue(ds.pcPaper);
      if (!pf || pf === state.finish) return;
      state.finish = pf;
      state.material = pf.material;
    } else if (ds.pcFrame != null) {
      if (state.frame === ds.pcFrame) return;
      state.frame = ds.pcFrame;
    } else if (ds.pcSize != null) {
      if (state.size === ds.pcSize) return;
      state.size = ds.pcSize;
    }
    render(reconcile());
    if (ds.pcMaterial != null || ds.pcFinish != null || ds.pcPaper != null) {
      var nextKey = 'size';
      if (ds.pcMaterial != null) nextKey = 'finish';
      else if (ds.pcFinish != null && steps.paper && !steps.paper.hidden) nextKey = 'paper';
      else if (state.finish && state.finish.framed) nextKey = 'frame';
      var next = root.querySelector('[data-pc-step="' + nextKey + '"]');
      if (next && !next.hidden && typeof next.scrollIntoView === 'function' && window.matchMedia('(max-width: 650px)').matches) {
        next.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }
  });

  // Testovací a ladicí rozhraní (používá se v automatických testech větví).
  root.configurator = {
    getState: function () { return { material: state.material, finish: state.finish && state.finish.value, group: state.finish && state.finish.group, paper: state.finish && state.finish.paper, frame: state.frame, size: state.size }; },
    select: function (key, value) {
      if (key === 'material') state.material = value;
      if (key === 'finish' || key === 'paper') { var f = finishByValue(value) || finishForGroup(value, state.finish); if (f) { state.finish = f; state.material = f.material; } }
      if (key === 'frame') state.frame = value;
      if (key === 'size') state.size = value;
      var notices = reconcile();
      render(notices);
      return notices;
    },
    options: function () {
      return {
        materials: materials.slice(),
        finishes: groupsFor(state.material).map(function (f) { return f.group; }),
        papers: papersFor(state.finish).map(function (f) { return f.value; }),
        frames: state.finish && state.finish.framed ? framesFor(state.finish) : [],
        sizes: state.finish ? sizesFor(state.finish, state.frame) : []
      };
    },
    variant: function () { return findVariant(state.finish, state.frame, state.size); }
  };

  /* ------------------------------------------------------------------
     Všechny varianty: Liquid (product.variants) vrací nejvýš 250. U děl s více
     variantami dohraje zbytek Storefront API (veřejný token v nastavení tématu);
     do té doby konfigurátor pracuje s prvními 250 variantami.
     ------------------------------------------------------------------ */
  function gidToId(gid) {
    var m = /(\d+)$/.exec(String(gid || ''));
    return m ? Number(m[1]) : null;
  }

  function loadAllVariants(done) {
    var sf = cfg.storefront;
    /* Porovnává se s počtem variant z Liquidu, NE s aktuálním polem — to je už doplněné
       ze statické tabulky, takže by tu vždy vyšlo „nic nechybí“ a ceny by zůstaly korunové. */
    if (!sf || !sf.token || !sf.handle || !(Number(cfg.variantsCount) > liquidVariantCount) || typeof fetch !== 'function') return;
    var api = sf.api || (window.location.origin + '/api/2026-01/graphql.json');
    var ctx = [];
    if (/^[A-Z]{2}$/.test(String(sf.country || ''))) ctx.push('country: ' + sf.country);
    if (/^[A-Z]{2,3}$/.test(String(sf.language || ''))) ctx.push('language: ' + sf.language);
    var query = 'query Varianty($handle: String!, $after: String)' + (ctx.length ? ' @inContext(' + ctx.join(', ') + ')' : '') +
      ' { product(handle: $handle) { variants(first: 250, after: $after) { pageInfo { hasNextPage endCursor }' +
      ' nodes { id title availableForSale price { amount } selectedOptions { name value } image { url } } } } }';
    var all = [];
    function page(after) {
      fetch(api, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': sf.token },
        body: JSON.stringify({ query: query, variables: { handle: sf.handle, after: after } })
      }).then(function (r) { return r.json(); }).then(function (j) {
        var conn = j && j.data && j.data.product && j.data.product.variants;
        if (!conn || !conn.nodes) return;
        conn.nodes.forEach(function (n) { all.push(n); });
        if (conn.pageInfo && conn.pageInfo.hasNextPage) {
          page(conn.pageInfo.endCursor);
          return;
        }
        done(all.map(function (n) {
          var o = n.selectedOptions || [];
          return {
            id: gidToId(n.id),
            title: n.title,
            available: !!n.availableForSale,
            price: Math.round(parseFloat(n.price && n.price.amount || '0') * 100),
            option1: o[0] ? o[0].value : null,
            option2: o[1] ? o[1].value : null,
            option3: o[2] ? o[2].value : null,
            featured_image: n.image && n.image.url ? { src: n.image.url } : null
          };
        }));
      }).catch(function () { /* zůstávají varianty z Liquidu */ });
    }
    page(null);
  }

  initFromVariant(cfg.selectedVariant);
  render(reconcile());

  loadAllVariants(function (all) {
    if (!all || all.length < liquidVariantCount) return;
    var selectedMissing = !!cfg.selectedVariant && !variants.some(function (x) { return String(x.id) === String(cfg.selectedVariant); });
    var prevFinish = state.finish ? state.finish.value : null;
    variants = all;
    buildIndex();
    if (selectedMissing) {
      initFromVariant(cfg.selectedVariant);
    } else {
      state.finish = prevFinish ? finishByValue(prevFinish) : null;
    }
    render(reconcile());
    root.dispatchEvent(new CustomEvent('configurator:variants', { detail: { count: variants.length } }));
  });
})();
